module.exports = __webpack_public_path__ + "img/pic_map_brazil_S.724d8681.jpg";